import constants from "../constants";
import { repairkits } from "../web3/SFM-RepairKitConstants";
import { spaceships } from "../web3/SFM-SpaceshipConstants";
export const RepairKitsData = [  
  {
    name: 'Supply BB1',
    type: 'Repair Kit',
    description: constants.Supply_BB1,
    price:"$5,00",
    image:"https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmQQKjiBZ3LVHcHgLmuvc8QyCn1WpNMPQxxcsvwMGohoDK/repaire%20kit/Supply_BB1.gif",
    category:repairkits.supplyBB1
  }, { 
    name: 'Supply BB2',
    type: 'Repair Kit',
    description: constants.Supply_BB2,
    price:"$6,00",
    image:"https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmQQKjiBZ3LVHcHgLmuvc8QyCn1WpNMPQxxcsvwMGohoDK/repaire%20kit/Supply_BB2.gif",
    category:repairkits.supplyBB2
  }, { 
    name: 'Supply BB3',
    type: 'Repair Kit',
    description: constants.Supply_BB3,
    price:"$8,00",
    image:"https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmQQKjiBZ3LVHcHgLmuvc8QyCn1WpNMPQxxcsvwMGohoDK/repaire%20kit/Supply_BB3.gif",
    category:repairkits.supplyBB3
  }, {
    name: 'Supply BB4',
    type: 'Repair Kit',
    description: constants.Supply_BB4,
    price:"$7,00",
    image:"https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmQQKjiBZ3LVHcHgLmuvc8QyCn1WpNMPQxxcsvwMGohoDK/repaire%20kit/Supply_BB4.gif",
    category:repairkits.supplyBB4
  }
];
